var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecycle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2h6",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.1h-1.9v8.1a1.4 1.4 0 01-1.4 1.4H4.3a1.4 1.4 0 01-1.4-1.4V5.1H1V3.9h14v1.2zm-10.9 0h7.8v8.1a.2.2 0 01-.2.2H4.3a.2.2 0 01-.2-.2V5.1zM7.4 7v4h1.2V7H7.4z",
    fill: "#7D8085"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUgMkgxMSIgc3Ryb2tlPSIjN0Q4MDg1IiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1IDUuMDk5OTZIMTMuMVYxMy4yQzEzLjEgMTMuOTczMiAxMi40NzMyIDE0LjYgMTEuNyAxNC42SDQuM0MzLjUyNjggMTQuNiAyLjkgMTMuOTczMiAyLjkgMTMuMlY1LjA5OTk2SDFWMy44OTk5NkgxNVY1LjA5OTk2Wk00LjEgNS4wOTk5NkgxMS45VjEzLjJDMTEuOSAxMy4zMTA1IDExLjgxMDUgMTMuNCAxMS43IDEzLjRINC4zQzQuMTg5NTQgMTMuNCA0LjEgMTMuMzEwNSA0LjEgMTMuMlY1LjA5OTk2Wk03LjQgN1YxMUg4LjZWN0g3LjRaIiBmaWxsPSIjN0Q4MDg1Ii8+Cjwvc3ZnPgo=";
export { SvgRecycle as ReactComponent };